import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import { Tag } from "primereact/tag";
import { getEventTypeDisplayProps } from "../../../../utils/eventTypes";

const EventDetailExtraComponent = ({ event }) => {
  const startSate = new Date(event?.start_date);
  const formattedStartDate = ToFormatedDateForEvents(startSate, event?.all_day);
  const endSate = new Date(event?.end_date);
  const formattedEndDate = ToFormatedDateForEvents(endSate, event?.all_day);

  // Get event type display properties for Tag component
  const eventTypeProps = getEventTypeDisplayProps(
    event?.event_type, 
    event?.start_date, 
    event?.end_date
  );

  return (
    <MeaDetailCard>
      <MeaDetailField 
        field="Type d'évènement" 
        value={<Tag {...eventTypeProps} />} 
      />
      <MeaDetailField field="Date de début" value={formattedStartDate} />
      <MeaDetailField field="Date de fin" value={formattedEndDate} />
    </MeaDetailCard>
  );
};

export default EventDetailExtraComponent;
